(function () {
  var LEASELINK_LABEL = 'Finansowanie dla firm';
  var LUKAS_LABEL = 'Oblicz ratę — Credit Agricole';

  function payments() {
    return document.querySelector('#card-sticky-scope .pc-payments');
  }

  // Wyróżniona końcówka linku ("sprawdź warunki") jest osobnym elementem, więc
  // podkreślenie obejmuje tylko ją — całość składamy z tekstów z szablonu.
  function textLink(label, onClick, cta) {
    var link = document.createElement('button');

    link.type = 'button';
    link.className = 'pc-payments__link';
    link.appendChild(document.createTextNode(cta ? label + ' ' : label));

    if (cta) {
      var accent = document.createElement('span');

      accent.className = 'pc-payments__link-cta';
      accent.textContent = cta;
      link.appendChild(accent);
    }

    link.addEventListener('click', onClick);

    return link;
  }

  // Widget bywa podpięty pod zdarzenia wskaźnika, nie pod samo "click".
  function forwardClick(target) {
    var events = ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'];

    events.forEach(function (type) {
      target.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));
    });
  }

  // Baner Credit Agricole to input[type="image"] w formularzu wysyłanym do
  // eWniosku. Nie podmieniamy go na własny przycisk — klikamy go programowo,
  // żeby POST poszedł dokładnie tak jak przy kliknięciu w grafikę.
  function setupLukas() {
    var container = document.querySelector('#credit-agricole-button');

    if (!container || container.querySelector('.pc-payments__link')) {
      return;
    }

    var image = container.querySelector('input[type="image"], img');

    if (!image) {
      return;
    }

    // alt obrazka niesie nazwę pliku z serwera CA, więc etykietę podaje szablon
    var label = (container.getAttribute('data-label') || '').trim() || LUKAS_LABEL;

    container.appendChild(textLink(label, function () {
      image.click();
    }));
  }

  // Przycisk LeaseLink to web component ze shadow DOM. Gdy shadow root jest
  // otwarty, klikamy w jego wnętrze; przy zamkniętym zostaje sam host.
  function leaselinkTarget(wrapper) {
    var host = wrapper.querySelector('leaselink-button') || wrapper.querySelector('button, a');

    if (host && host.shadowRoot) {
      var inner = host.shadowRoot.querySelector('button, a, [role="button"]');

      if (inner) {
        return inner;
      }
    }

    return host || wrapper;
  }

  // Zewnętrzny skrypt (rep.leaselink.pl) wstrzykuje czarny przycisk pod
  // koszykiem, gdzie konkurował z zakupem (Z4). Sam przycisk chowa CSS —
  // tutaj przenosimy go do bloku płatności i podstawiamy link tekstowy.
  function setupLeaselink() {
    var wrapper = document.querySelector('.leaselink-button-wrapper');

    if (!wrapper || wrapper.dataset.financeLinked) {
      return false;
    }

    var target = payments() || wrapper.parentElement;
    var host = payments();
    var text = (host && host.dataset.financeText)
      || (wrapper.textContent || '').replace(/\s+/g, ' ').trim()
      || LEASELINK_LABEL;
    var cta = host ? host.dataset.financeCta : '';

    // Widget nie reaguje na zdarzenia wysłane skryptem, więc zamiast go chować
    // kładziemy go przezroczyście na linku: użytkownik widzi tekst, a klika
    // fizycznie w przycisk LeaseLinka. Handler zostaje jako zapas, gdyby
    // nakładka nie pokryła całego obszaru.
    var slot = document.createElement('span');

    slot.className = 'pc-payments__finance-slot';
    slot.appendChild(textLink(text, function () {
      forwardClick(leaselinkTarget(wrapper));
    }, cta));

    wrapper.dataset.financeLinked = '1';
    wrapper.classList.add('is-overlay');
    slot.appendChild(wrapper);
    target.appendChild(slot);

    return true;
  }

  // Widget potrafi wejść w DOM długo po starcie strony, a na wolniejszym
  // środowisku nawet po kilkudziesięciu sekundach — obserwujemy do skutku,
  // zamiast zgadywać limit czasu.
  function init() {
    setupLukas();

    if (setupLeaselink()) {
      return;
    }

    var observer = new MutationObserver(function () {
      if (setupLeaselink()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
